import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_END_POINTS } from '@app/config/api.constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConcentrateService {

  private $viewConcentrate: BehaviorSubject<any> = new BehaviorSubject(null)
  private $submitTemplate: BehaviorSubject<any> = new BehaviorSubject(null)

  constructor(
    private http: HttpClient
  ) { }

  public set setViewConcentrate(presetId: any){
    this.$viewConcentrate.next(presetId)
  }

  public get viewConcentrateLogic (): Observable<any> {
    return this.$viewConcentrate.asObservable()
  }

  public set submitTemplate(submitTmep: any){
    this.$submitTemplate.next(submitTmep)
  }

  public get getSubmitTemplate (): Observable<any> {
    return this.$submitTemplate.asObservable()
  }

  createConcentrateLogic(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.SETUP.CONCENTRATE.create, data)
  }

  getConcentrateLogic(): Observable<any> {
    return this.http.get(API_END_POINTS.SETUP.CONCENTRATE.data)
  }

  updateConcentrateLogic(concentrateId: string, data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.SETUP.CONCENTRATE.update}?id=${concentrateId}`, data)
  }

  getConcentrateLogicByID(concentrateId: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.SETUP.CONCENTRATE.data}?id=${concentrateId}`)
  }
}
